import React from "react";
import { PagePrint } from "../PagePrint";

import BarcodesTable from "./BarcodesTable/BarcodesTable";
import PackingTable from "./PackingTable/PackingTable";

import { TableStack } from "./styles";
import { getBarcodes } from "./helper";

export const PackingBarcodes = ({
  serialization = [],
  items = [],
  weight,
  packagedDate,
  number,
}) => {
  const barcodes = getBarcodes(serialization);

  return (
    <>
      {barcodes?.map((list, index) => (
        <PagePrint
          cardProps={{ className: "print-only", id: `page-${index + 2}` }}
        >
          <TableStack>
            <BarcodesTable barcodes={list} />
            {/* {!index && (
              <PackingTable
                items={items}
                weight={weight}
                packagedDate={packagedDate}
                number={number}
              />
            )} */}
          </TableStack>
        </PagePrint>
      ))}
    </>
  );
};

export default PackingBarcodes;
